var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipTailLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000189781 8L-0.000177446 -2.22544e-07L10.1934 9.53674e-07C5.94716 1.04666 1.23958 4.02537 -0.000189781 8Z",
    fill: "#2C3558"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipTailLeft);
export default __webpack_public_path__ + "static/media/tooltip-tail-left.8df61e7565e80ec4772d9eda36eee2e8.svg";
export { ForwardRef as ReactComponent };